import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import stageOneLoading from './modules/stage-one-loading'
import coupons from './modules/coupons'
import creditCommon from './modules/credit-common'
import home from './modules/home'
import guideOne from './modules/guide-one'
import guideTwo from './modules/guide-two'
import authorization from './modules/authorization'
import apollo from './modules/apollo'
import rcext from './modules/rcext'
import native from './modules/native'
import personInfo from './modules/person-info'
import creditConfig from './modules/credit-config'
import curp from './modules/curp'
import common from './modules/common'
import login from './modules/login'
import retainPop from './modules/retain-pop'
import vendor from './modules/vendor'

Vue.use(Vuex)

/**
 * 根store仅做模块管理
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const store = new Vuex.Store<any>({
  modules: {
    user: {
      namespaced: true,
      ...user,
    },
    ['stage-one-loading']: {
      namespaced: true,
      ...stageOneLoading,
    },
    coupons: {
      namespaced: true,
      ...coupons,
    },
    ['credit-common']: {
      namespaced: true,
      ...creditCommon,
    },
    home: {
      namespaced: true,
      ...home,
    },
    ['guide-one']: {
      namespaced: true,
      ...guideOne,
    },
    ['guide-two']: {
      namespaced: true,
      ...guideTwo,
    },
    authorization: {
      namespaced: true,
      ...authorization,
    },
    apollo: {
      namespaced: true,
      ...apollo,
    },
    rcext: {
      namespaced: true,
      ...rcext,
    },
    native: {
      namespaced: true,
      ...native,
    },
    ['person-info']: {
      namespaced: true,
      ...personInfo,
    },
    ['credit-config']: {
      namespaced: true,
      ...creditConfig,
    },
    curp: {
      namespaced: true,
      ...curp,
    },
    common: {
      namespaced: true,
      ...common,
    },
    login: {
      namespaced: true,
      ...login,
    },
    retainPop: {
      namespaced: true,
      ...retainPop,
    },
    vendor: {
      namespaced: true,
      ...vendor,
    }
  }
})

export default store
